import React from "react";
import { MapPin, Phone, Mail } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { Seo } from "../components/Seo";
import { CTABand } from "../components/Layout";
import { SERVICE_AREAS, CONTACT } from "../data";

const ServiceArea = () => (
  <div data-testid="service-area-page">
    <Seo
      title="Service Area | Bright Oak Renovations"
      description="Bright Oak Renovations proudly serves Cambridge, Kitchener, Waterloo, Guelph and surrounding communities in Ontario. See if we cover your area."
      path="/service-area"
    />
    <PageHeader
      label="Where We Work"
      title="Proudly serving Waterloo Region"
      subtitle="Bright Oak is based in Cambridge and works throughout the tri-cities and surrounding communities. If your home is nearby, we'd love to help."
      testid="service-area-header"
    />

    <section className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-28">
      <div className="grid lg:grid-cols-2 gap-14 items-start">
        {/* Map */}
        <div className="border border-[#2B2B2B]/15 overflow-hidden">
          <iframe
            title="Bright Oak Renovations Service Area"
            data-testid="service-area-map"
            src="https://www.google.com/maps?q=Cambridge,Ontario&z=10&output=embed"
            className="w-full h-[460px] grayscale-[0.2]"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

        {/* Areas list */}
        <div>
          <p className="section-label">Cities & Communities</p>
          <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tight mt-4">Areas we serve</h2>
          <p className="text-[#5C5C5C] mt-4 leading-relaxed">
            Not sure if you're in our range? Reach out — we regularly take on projects in
            neighbouring townships too.
          </p>
          <div className="grid sm:grid-cols-2 gap-4 mt-8">
            {SERVICE_AREAS.map((a) => (
              <div key={a.city} data-testid={`area-${a.city.toLowerCase()}`} className="bg-white border border-[#2B2B2B]/10 p-5 flex items-start gap-3 hover:border-[#C68B4E] transition-colors">
                <MapPin size={20} strokeWidth={1.5} className="text-[#C68B4E] mt-0.5 shrink-0" />
                <div>
                  <div className="font-bold">{a.city}, ON</div>
                  <div className="text-xs text-[#5C5C5C] mt-1 leading-relaxed">{a.note}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Contact strip */}
      <div className="grid sm:grid-cols-3 gap-4 mt-16">
        <a href={`tel:${CONTACT.phone.replace(/[^0-9+]/g, "")}`} className="bg-[#2B2B2B] text-[#F7F3EC] p-8 flex items-center gap-4 hover:bg-[#C68B4E] transition-colors" data-testid="area-phone">
          <Phone size={24} strokeWidth={1.5} className="text-[#C68B4E] group-hover:text-white" />
          <div>
            <div className="text-xs uppercase tracking-widest text-[#F7F3EC]/60">Call us</div>
            <div className="font-bold">{CONTACT.phone}</div>
          </div>
        </a>
        <a href={`mailto:${CONTACT.email}`} className="bg-[#2B2B2B] text-[#F7F3EC] p-8 flex items-center gap-4 hover:bg-[#C68B4E] transition-colors" data-testid="area-email">
          <Mail size={24} strokeWidth={1.5} className="text-[#C68B4E]" />
          <div>
            <div className="text-xs uppercase tracking-widest text-[#F7F3EC]/60">Email us</div>
            <div className="font-bold text-sm break-all">{CONTACT.email}</div>
          </div>
        </a>
        <div className="bg-[#2B2B2B] text-[#F7F3EC] p-8 flex items-center gap-4">
          <MapPin size={24} strokeWidth={1.5} className="text-[#C68B4E]" />
          <div>
            <div className="text-xs uppercase tracking-widest text-[#F7F3EC]/60">Visit us</div>
            <div className="font-bold text-sm">{CONTACT.location}</div>
          </div>
        </div>
      </div>
    </section>

    <CTABand />
  </div>
);

export default ServiceArea;
